module.exports = __webpack_public_path__ + "media/images/country_flags/world-0f9540e17e3e47bc8d2a94739f081ba3.png";